import React from 'react';
import styled from 'styled-components';
import BreadCromb from '../components/HomeComp/BreadCromb';
import { PostData } from '../components/Functions/SendingData';
import { ResizeImage } from '../components/Functions/ResizeImage';
import { insertError } from '../components/StakcableError';
import topImg1 from '../assets/imageOfAboutus/top2.png'
import topImg from '../assets/imageOfAboutus/top.png'
import{TextInputWTitle} from '../components/NewComp/SmallComps/TextInputWTitle'
import MainLogo from '../assets/luxWhite.svg';
import { LocationData } from '../components/HomeComp/Location';


const Styles = styled.div`
    margin-bottom: 2rem;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    color: var(--text-2);
    .connect-form{
        display: flex;
        flex-direction: column;
        position: relative;
        width: 100%;
        margin-bottom: 3.4rem;
        .backgroud-img{
            position: absolute;
            inset: 0;
            object-fit: cover;
            background-repeat: round;
        }
        .content-connect{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            height: 33.5rem;
            .left-side {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-grow: 1;
                width: 50%;
            }
            .logo-luxinlux{
                position: relative;
                /* margin:auto  ; */
                /* margin-left: 6rem; */
                display: flex;
                height: 23rem;
                aspect-ratio: 1;
                flex-direction: column;
                border-radius: 250px;
                z-index: 3;
                .lux-svg{
                    width: 80%;
                    margin: auto;
                }
            }
            .message{
                display: flex;
                flex-direction: column;
                z-index: 2;
                width: 50%;
                .connect {
                    background: var(--body-2);
                    padding: 1rem 1rem 2rem;
                    width: calc(calc(100% - 2rem) - var(--padding));
                    display: flex;
                    flex-direction: column;       
                    border-radius: var(--border-radius-2);
                    margin:auto var(--padding);
                    box-shadow: var(--shadow-14);
                    .top-title{
                        font-size:1.25rem;
                        font-weight: 700;
                        width: 100%;
                        border-bottom: 1px solid var(--gray-3);
                        padding: 0 0 1rem;

                    }
                }
                .msg-form{
                    padding:0.5rem 0;
                    display: grid;
                    grid-template-columns: repeat(2 ,49%);
                    grid-gap: 2%;
                    width: calc(100%);
                    margin-top: 1rem;
                    :nth-child(1) ,:nth-child(4){
                        grid-column: span 2;                       
                    }
                    .send{
                        position: relative;
                        border-radius: var(--border-radius-4);
                        color: var(--text-3);
                        background: var(--primary-9);
                        /* padding: 0.5rem; */
                        padding: 0.7rem 0.5rem 1rem;
                        font-weight: 500;
                        font-size: 1.25rem;
                        text-align: center;
                        justify-content: center;
                        align-items: center;
                        grid-column: span 2;
                        width:calc(100% - 1rem);
                    }
                }
            }
        }
    }
    @media screen and (max-width : 850px){
        .connect-form{
            margin-bottom: 1rem;
            .backgroud-img{
                inset:0 0 0;
                height: calc(15rem + var(--top-gap));
                object-fit: cover;
            }
            .content-connect{
                margin-top: -1rem;
                align-items: center;
                height: auto;
                flex-direction: column-reverse;
                .logo-luxinlux{
                    position: absolute;
                    height: 8rem;
                    inset: 12.5rem 0;
                    margin:0 auto;
                }
                .message{
                    margin-top: 10rem;
                    width: 100%;
                    .connect{ 
                        padding:4rem 1rem 1rem;
                        width: auto;
                    }
                    .msg-form{
                        display: flex;
                        flex-direction: column;
                        flex-wrap: wrap;
                        margin: 0;
                        .send{
                            margin: 0.5rem auto;
                            font-size: 0.8rem;
                            padding:0.7rem 0.5rem 1rem;
                            width: calc(100% - 2rem);
                        }
                    }
                } 
            }
        }
        
    }
`;

const form = [
    {label: 'نام و نام خانوادگی' , value:'', name:'username', mode:'text', type:'text'},
    {label: 'شماره تماس' , value:'', name:'mobile', mode:'tel', type:'tel'},
    {label: 'ایمیل' , value:'', name:'email', mode:'email', type:'email'},
    {label: 'متن پیام' , value:'NOT_DESC', name:'NOT_DESC', mode:'text', type:'text'},
]

class ContactUs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userdata: JSON.parse(localStorage.getItem('userdata')),
            breadData :[
                {
                    name: 'خانه',
                    link: '/'
                },
            ],
            data:{
                NOT_DESC:'',
                USERNAME:'',
                tel:'',
                email:'',
                attach:[],
            }
        };
    }
    componentDidMount() { 
        window.scrollTo({
                top:0 ,
                left: 0,
                behavior: 'smooth'
            });
            this.makeBreadCrombData()
    }
    makeBreadCrombData = ()=> {
        let mainName = 'خانه';
        let startLink = '/';
        let breadData = [
            {
                name: mainName,
                link: startLink
            },
        ]
        if(this.props.match.path=== '/contactus'){
            breadData.push(
                {
                    name: 'ارتباط با ما',
                    link: '/contactus/'
                }
            )
        }
        this.setState({
            breadData: breadData,
        })
    }
    sendmssg= async()=>{
        let formData = new FormData()
        let datas = this.state.data
        if(datas.NOT_DESC){
            this.setState({
                sending :true
            })
            let allDataMsg = 'نام: '+ datas.USERNAME  + '،\n'+'شماره تماس: ' + datas.tel  + '،\n'+'ایمیل: ' + datas.email  + '،\n' +'متن پیام : ' + datas.NOT_DESC
            if(this.state.userdata){
                formData.append('api_token',this.state.userdata.token);
                formData.append('SENDER_U_CODE',this.state.userdata.usercode )
            }else{
                formData.append('SENDER_U_CODE', -1 )
            }
            formData.append('SENDER_SH_CODE', -1 )
            formData.append('NOT_DESC', allDataMsg )
            formData.append('NOT_SUB_CODE', 22);
            formData.append('NOT_SIT_CODE',1);
            formData.append('NOT_T_CODE',1);
            if(datas.attach.length > 0){
                formData.append('NOT_ATTACHMENT',await ResizeImage(datas.att[0],700 ,700), 'attach.webp');
            }
            PostData(process.env.REACT_APP_API + '/api/v1/notification_header/new_full_insert', formData,this, this.process)
        }else{
            insertError('قسمت مربوط به متن درخواست خود را پر کنید','red',5000);
        }
    }
    process(obj, response){
        response = JSON.parse(response);
        if (response.status === 'success') {
            obj.setState({
                response: 'success',
                objectData: response.data,
                sending: false,
                data:{
                    NOT_DESC:'',
                    USERNAME:'',
                    tel:'',
                    email:'',
                    attach:[],
                }
            });
        } else if (response.status === 'error') {
            insertError(response.data.message,'red',5000);
            obj.setState({
                error:'response.data.message',
                response: 'error',
                sending: false,
                data:{
                    NOT_DESC:'',
                    USERNAME:'',
                    tel:'',
                    email:'',
                    attach:[],
                }
            });
        } else if (response.status === 'error-no-internet') {
            insertError(response.data.message,'red',5000);
            obj.setState({
                sending: false,
            });
        }
    }
    inputchange=(e ,name)=>{
        let data = this.state.data
        if(name === 'photo'){
            this.messageAtt(e)
        }
        switch(name){
            case 'NOT_DESC':
                data.NOT_DESC = e.target.value;
                break
            case 'username':
                data.USERNAME = e.target.value;
                break
            case 'mobile':
                data.tel = e.target.value;
                break
            case 'email':
                data.email = e.target.value;
                break
            case 'message':
                data.NOT_DESC = e.target.value;
                break
            default:
                break  
        }
        this.setState({
            data : data
        })
    }
    messageAtt=(e) => {
        this.setState({...this.state.data, attach: [e.target.files[0]] })
    };
   
    render() {
        return (
            <Styles>
                <div className='connect-form' >
                    <div className='backgroud-img' style={{backgroundImage: (window.innerWidth > 850 ? `url(${topImg1})` : `url(${topImg})`) }}></div>
                    <BreadCromb data={this.state.breadData} classname='glass-style glass2 with-margin'/>
                    <div className='content-connect'>
                        <div className=' message' >
                            <div className='connect'>
                                <span className='top-title'>ارتباط با ما</span>
                                <div className='msg-form'>
                                { 
                                    form.map((value , index)=>{
                                        return <TextInputWTitle key={index} keys={index} style={{gridColumn : ((index === 2 || index === 3) ? 'span 2' : '')}} error='' name={value.name} title={value.label} type={value.type} inputmode={value.mode} value={this.state.data[value.value]} onchange={(e)=> this.inputchange(e , value.name)} required={true}/>
                                    })
                                }
                                <div className='send fields' onClick={this.sendmssg}>
                                    ارسال پیام
                                </div>
                                </div>
                            </div>
                        </div>
                        <div className='left-side'>
                            <div className='logo-luxinlux glass3'>
                                <img src={MainLogo} alt={'luxinlux'} className='lux-svg'/>
                            </div>
                        </div>
                    </div>

                </div>
                {LocationData()}
            </Styles>
        )
    }
}

export default ContactUs;